export const IMAGE_LIMIT_SIZE_20MB = 1024 * 1024 * 20; // 20MB
export const IMAGE_LIMIT_SIZE_10MB = 1024 * 1024 * 10; // 10MB
export const IMAGE_LIMIT_SIZE_5MB = 1024 * 1024 * 5; // 5MB
export const IMAGE_LIMIT_SIZE_3MB = 1024 * 1024 * 3; // 3MB
